import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { useSystem } from "../context/System";
import { useSystems } from "../context/Systems";

const SexySelector = () => {
  const { system, setSystem } = useSystem();
  const { systems } = useSystems();
  const [index, setIndex] = useState(0); // eslint-disable-line no-eval
  console.log(index);

  const handle_select = (selectedIndex, e) => {
    const sexy = document.getElementById("sexySelector");
    sexy.querySelector(".carousel-item.active img").classList.add("opacity-0");
    const next = sexy.querySelector(".carousel-item.active").nextSibling;
    const prev = sexy.querySelector(".carousel-item.active").previousSibling;
    const first = sexy.querySelector(".carousel-item");
    const last = sexy.querySelector(".carousel-item:last-child");
    let btn_prev_class = "carousel-control-prev-icon";
    let system_to_show_next = next != null ? next.getAttribute("system") : first.getAttribute("system");

    if (!e.target.classList.contains(btn_prev_class)) {
      system_to_show_next = next != null ? next.getAttribute("system") : first.getAttribute("system");
    } else {
      system_to_show_next = prev != null ? prev.getAttribute("system") : last.getAttribute("system");
    }

    setSystem(systems.filter((system) => system.identifier === system_to_show_next)[0]);
    setIndex(selectedIndex);
  };

  const handle_slid = (eventKey, direction) => {
    // eslint-disable-next-line
    Array.from(document.getElementById("sexySelector").querySelectorAll(".carousel-item")).map((elem) => {
      elem.querySelector("img").classList.remove("opacity-0");
    });
  };

  // const handle_active_system_manager = async ()=>{
  // 	setTimeout(()=>{
  // 		const sexy = document.getElementById("sexySelector");
  // 		console.log(sexy);
  // 		let i=0;
  // 		Array.from(sexy.querySelectorAll(".carousel-item")).map((elem)=>{
  // 			console.log(elem);
  // 			if(elem.getAttribute('system') == system.identifier){
  // 				elem.classList.add("active");
  // 				setIndex(i);
  // 				console.log(system.identifier);
  // 			}else{
  // 				elem.classList.remove("active");
  // 			}
  // 			i++;
  // 		});
  // 		sexy.querySelector(".carousel-item[system='"+system.identifier+"']");

  // 	}, 1000)
  // }

  //   const handle_my_load = () => {
  //     //handle_active_system_manager();
  //   };

  //   useEffect(() => handle_my_load(), []);

	return systems && (
		<div id="sexySelector" className="sexy-selector">
			<Carousel activeIndex={systems.filter(sys => sys.identifier === system.identifier)[0].index} onSelect={handle_select} onSlid={handle_slid} fade keyboard={false} interval={null} indicators={false}>
				
				{ systems.map((sys)=><Carousel.Item key={sys.identifier} system={sys.identifier}>
					<div className="sexy-option">
						<img
							className=""
							src={sys.logo}
							alt={sys.name}
							width={250}
							height={50}
						/>
					</div>
				</Carousel.Item>)}
			</Carousel>
			<small className="small fw-light">Use the arrows to choose a different platform.</small>
		</div>
	)
}

export default SexySelector;
